<template>
    <app-layout-new :title="form.title +' | '+ tour_title" :form="form">

        <template v-slot:left-area>
            <div class="my-5 text-center">
            <Link :href="route('tour.edit', tour_identifier)" class="btn btn-gradient btn-sm">
                Back
            </Link>
        </div>
        </template>

        <div class="flex lang-box">
            <a href="#" class="active">{{ fallback_language }}</a>
        </div>

        <section class="border border-gray-800 p-3">
            <h3 class="text-white text-2xl font-bold uppercase">General</h3>
            <div class="flex">
                <label>Title</label>
                <span v-if="errors.title" class="errormessage">{{ errors.title }}</span>
            </div>
            <input class="input-black" type="text" id="copyright_text" v-model="form.title">

            <div class="flex">
                <label>Subtitle</label>
                <span v-if="errors.description" class="errormessage">{{ errors.description }}</span>
            </div>
            <input class="input-black" type="text" id="copyright_text" v-model="form.description">

        </section>

        <section class="border border-gray-800 p-3">
            <h3 class="text-white text-2xl font-bold uppercase">Location</h3>
            <div class="flex">
                <div class="w-2/3 p-3">
                    <MapsPlugin
                        v-bind:latitude="form.latitude"
                        v-bind:longitude="form.longitude"
                        @update:location="updateLocation($event)"
                    ></MapsPlugin>
                </div>
                <div class="w-1/3 p-3">
                    <div class="flex">
                        <label>Latitude</label>
                        <span v-if="errors.latitude" class="errormessage">{{ errors.latitude }}</span>
                    </div>
                    <input class="input-black" type="number" v-model="form.latitude" v-on:change="">

                    <div class="flex">
                        <label>Longitude</label>
                        <span v-if="errors.longitude" class="errormessage">{{ errors.longitude }}</span>
                    </div>
                    <input class="input-black" type="number" v-model="form.longitude" v-on:change="">
                </div>
            </div>
        </section>
        <button @click.prevent="storeStation" class="btn btn-gradient mt-2">Save station</button>

    </app-layout-new>
</template>

<script>
import AppLayoutNew from '@/Layouts/AppLayoutNew.vue'
import { Link } from '@inertiajs/inertia-vue3'
import MapsPlugin from "@/Components/MapsPlugin";

export default {


    components: {
        AppLayoutNew,
        Link,
        MapsPlugin
    },
    props: {
      errors: Object,
    },
    mounted(){
        this.form.current_language = this.$page.props.tour.data.fallback_language;
        this.tour_title = this.$page.props.tour.data.title.localized_text[this.form.current_language];
    },
    data(){
        return{
            tour_identifier: this.$page.props.tour.data.identifier,
            tour_title: this.$page.props.tour.data.title,
            fallback_language: this.$page.props.tour.data.fallback_language,
            languages: this.$page.props.tour.data.languages,
            form: this.$inertia.form({
                _method: 'POST',
                title: '',
                description: '',
                latitude: this.previousStationLocation('latitude'),
                longitude: this.previousStationLocation('longitude'),
                tour_identifier: this.$page.props.tour.data.identifier,
                current_language: null,
            })
        }
    },
    methods: {
        previousStationLocation(key) {
            const allStations = this.$page.props.tour.data.stations;
            if(allStations && Array.isArray(allStations) && allStations.length > 0) {
                const previousStation = allStations[allStations.length - 1];
                return parseFloat(previousStation.location[key]) || undefined;
            }
            return undefined;
        },

        updateLocation(e) {
            this.form.latitude = e.detail.lat;
            this.form.longitude = e.detail.lng;
        },
        storeStation(e){
            e.target.disabled = true;
            setTimeout(() => e.target.disabled = false, 2000)
            this.form.post(route('station.store', this.tour_identifier), {
                preventScroll: true,
                onSuccess: () => {
                    e.target.disabled = false;
                }
            });
        }
    }
}
</script>
